import React from "react";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

type Props = {
  actionsOpen: boolean;
  actionsToggle: () => void;
  children?: React.ReactNode;
  className?: string;
};

export default function ActionDropdown(props: Props) {
  return (
    <Dropdown
      nav
      isOpen={props.actionsOpen}
      toggle={props.actionsToggle}
      className={props.className ? `${props.className} text-right` : "col-4 text-right"}>
      <DropdownToggle className="nav-link pr-0 cursor-pointer" color="" tag="a">
        <i className="far fa-bars"></i>
      </DropdownToggle>
      <DropdownMenu right>{props.children}</DropdownMenu>
    </Dropdown>
  );
}
